<template>
  <div>
    <v-dialog v-model="counter_top_sales_invoice_report" max-width="1000" persistent>
      <v-card :loading="loading" class="sales-invoice-report">
        <v-card-text class="pt-3">
          <v-row dense>
            <v-col cols="12" style="font-size: 18px;" class="text-center">
              <b>{{project_details.order_type=='2' ? 'Estimate' : 'Sales Order'}}</b>
              <v-divider class="mt-3 mb-3"></v-divider>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="4">
              <v-row dense>
                <v-col cols="3" style="max-width: 22%;">
                  <v-img :src="company_details.logo_path" width="60"></v-img>
                </v-col>
                <v-col class="license-number" style="line-height: 18px;">
                  <div style="font-size: 16px;">{{company_details.name}}</div>
                  <div class="ml-2">{{ company_details.license_number}}</div>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="4" class="text-center">
              <!-- <div class="ml-2" style="font-size: 18px;"><i><b>Since {{ company_details.company_start_year}}</b></i></div> -->
              <div class="ml-2" style="font-size: 18px;">
                <i>
                  <b></b>
                </i>
              </div>
            </v-col>
            <v-col cols="4" class="text-right">
              Tel :
              <b>{{ company_details.phone_number}}</b>
              <br />
              <a
                :href="company_details.website_link"
                target="_blank"
              >{{ company_details.website_link}}</a>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col
              cols="6"
            >{{company_details.shipping_address_line_1}}, {{company_details.shipping_city_details.city_name}}, {{company_details.shipping_state_details.short_name}} {{company_details.shipping_zip}}</v-col>
            <v-col
              cols="6"
              class="text-right"
            >{{company_details.email+'@'+company_details.domain_details.domain}}</v-col>
          </v-row>
          <v-row dense>
            <v-col cols="12">
              <v-simple-table dense class="custom-table-border">
                <tbody>
                  <tr class="grey lighten-2">
                    <td width="30%">
                      <i>Our Goal 100% Customer Satisfaction</i>
                    </td>
                    <td
                      width="20%"
                      style="font-size: 18px;"
                      class="text-center"
                    >{{project_details.order_type=='2' ? 'Estimate' : 'Sales Order'}} : {{company_details.company_id+'-'+project_details.project_id}}</td>
                    <td width="20%" class="text-center">Order Date: {{project_details.display_date}}</td>
                    <td
                      width="30%"
                      class="text-center"
                    >Est. Comp. Date: {{project_details.estimated_completed_date}}</td>
                  </tr>
                </tbody>
              </v-simple-table>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="12">
              <v-simple-table dense class="custom-table-border">
                <tbody>
                  <tr class="text-center">
                    <td width="20%" class="grey lighten-2">Billing</td>
                    <td width="30%">{{project_details.bill_to}}</td>
                    <td width="20%" class="grey lighten-2">Shipping</td>
                    <td
                      width="30%"
                    >{{(project_details.customer)?project_details.customer.full_name:''}}</td>
                  </tr>
                  <tr class="text-center">
                    <td width="20%" class="grey lighten-2">{{project_details.mobile}}</td>
                    <td width="30%">{{project_details.bill_to_address_1}}</td>
                    <td width="20%" class="grey lighten-2">{{project_details.mobile}}</td>
                    <td width="30%">{{project_details.p_address_1}}</td>
                  </tr>
                  <tr class="text-center">
                    <td width="20%" class="grey lighten-2"></td>
                    <td
                      width="30%"
                    >{{(project_details.bill_to_city_details)?project_details.bill_to_city_details.city_name+',':''}} {{(project_details.bill_to_state_details)?project_details.bill_to_state_details.short_name:''}} {{project_details.bill_to_zip}}</td>
                    <td width="20%" class="grey lighten-2"></td>
                    <td
                      width="30%"
                    >{{(project_details.city_details)?project_details.city_details.city_name+',':''}} {{(project_details.state_details)?project_details.state_details.short_name:''}} {{project_details.p_zip}}</td>
                  </tr>
                </tbody>
              </v-simple-table>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="12">
              <v-simple-table dense class="custom-table-border">
                <thead>
                  <tr class="grey lighten-2">
                    <th width="12%" class="text-center">Type</th>
                    <th width="55%" class="text-center">Name</th>
                    <th width="10%" class="text-center">Qty</th>
                    <th width="10%" class="text-right">Unit Px</th>
                    <th width="13%" class="text-right">Amount</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(row, index) in items" :key="index">
                    <td
                      class="text-center"
                    >{{(row.item_job == '2')?'Job':(row.item_job == '0') ? 'Item' : 'Stone'}}</td>
                    <td class="text-center">{{row.item ? row.item.item_name :''}}</td>
                    <td class="text-center">{{row.qty}}</td>
                    <td class="text-right">${{row.rate}}</td>
                    <td class="text-right">${{(row.rate * row.qty).toFixed(2)}}</td>
                  </tr>
                  <tr v-for="(row, index) in stones" :key="index">
                    <td class="text-center">Stone</td>
                    <td class="text-center">{{row.stone.item_name}}</td>
                    <td class="text-center">{{row.qty}}</td>
                    <td class="text-right">${{row.price}}</td>
                    <td class="text-right">${{(row.price * row.qty).toFixed(2)}}</td>
                  </tr>
                </tbody>
              </v-simple-table>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="12">
              <v-simple-table dense class="custom-table-border">
                <tbody>
                  <tr class="text-center">
                    <td width="20%" class="grey lighten-2">Sales Order Grand Total</td>
                    <td width="20%" class="grey lighten-2">50% Deposit Amount</td>
                    <td width="20%" class="grey lighten-2">Sales Order Amount</td>
                    <td width="20%" class="grey lighten-2">Payment Received</td>
                    <td width="20%" class="grey lighten-2">Balance Due</td>
                  </tr>
                  <tr class="text-center">
                    <td width="20%">{{(summary.grandTotal)?'$'+summary.grandTotal:''}}</td>
                    <td
                      width="20%"
                    >{{ summary.grandTotal ? '$' + (summary.grandTotal * 0.5).toFixed(2) : '' }}</td>
                    <td width="20%">{{(summary.salesOrderAmount)?'$'+summary.salesOrderAmount:''}}</td>
                    <td
                      width="20%"
                    >{{(summary.paymentReceived)? itemFormatWithDollar(summary.paymentReceived) : ''}}</td>
                    <td width="20%">{{(summary.balanceDue)?'$'+summary.balanceDue:''}}</td>
                  </tr>
                </tbody>
              </v-simple-table>
            </v-col>
          </v-row>
          <!-- <v-row dense="">
            <v-col cols="12">
              <v-simple-table dense class="custom-table-border">
                <thead>
                  <tr class="grey lighten-2">
                    <th width="13%" class="text-center">Sales Order<br>Grand Total</th>
                    <th width="35%" class="pa-0" colspan="3">
                      <v-simple-table dense class="custom-table-border grey lighten-2">
                        <thead>
                          <tr>
                            <th colspan="3" class="text-center" width="100%">Discount - Amount - ${{summary.totalDiscount}}</th>
                          </tr>
                          <tr>
                            <th class="text-center" width="34.6%">Dealer</th>
                            <th class="text-center" width="33%">Manager</th>
                            <th class="text-center" width="32.6%">Clearence</th>
                          </tr>
                        </thead>
                      </v-simple-table>
                    </th>
                    <th width="13%" class="text-center">Saler Order<br>Amount</th>
                    <th width="13%" class="text-center">Deposit<br>Required</th>
                    <th width="13%" class="text-center">Payment<br>Received</th>
                    <th width="13%" class="text-center">Balace<br>Due</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td class="text-right">{{(summary.grandTotal)?'$'+summary.grandTotal:''}}</td>
                    <td class="text-right" width="12.5%">{{(summary.multiplierDiscount)?'$'+summary.multiplierDiscount:''}}</td>
                    <td class="text-right" width="11.66%">{{(summary.managerDiscount)?'$'+summary.managerDiscount:''}}</td>
                    <td class="text-right" width="11.66%">{{(summary.clearanceDiscount)?'$'+summary.clearanceDiscount:''}}</td>
                    <td class="text-right">{{(summary.salesOrderAmount)?'$'+summary.salesOrderAmount:''}}</td>
                    <td class="text-right">{{(summary.depositRequire)?'$'+summary.depositRequire:''}}</td>
                    <td class="text-right">{{(summary.paymentReceived)? itemFormatWithDollar(summary.paymentReceived) : ''}}</td>
                    <td class="text-right"><b>{{(summary.balanceDue)?'$'+summary.balanceDue:''}}</b></td>
                  </tr>
                </tbody>
              </v-simple-table>
            </v-col>
          </v-row>-->

          <v-row dense class="mt-3">
            <v-col cols="12" class="d-flex">
              <span v-html="getReportText(4,1)"></span>
              <span class="align-self-end">
                <v-icon class="cursor-pointer" @click="openReportTextDialog(4,1)">mdi-border-color</v-icon>
              </span>
            </v-col>
          </v-row>
          <v-row dense class="mt-3" style="border: solid 1px;">
            <v-col cols="12" class="d-flex">
              <span v-html="getReportText(4,2)"></span>
              <span class="align-self-end">
                <v-icon class="cursor-pointer" @click="openReportTextDialog(4,2)">mdi-border-color</v-icon>
              </span>
            </v-col>
          </v-row>
          <v-row dense class="mt-10">
            <v-col cols="5" class="text-center">
              <br />
              <v-divider></v-divider>
              {{project_details.bill_to}}
            </v-col>
            <v-col cols="2"></v-col>
            <v-col cols="5" class="text-center">
              We Thank you for doing Business with {{company_details.name}}
              <v-divider></v-divider>
              {{user_name}}
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn color="error" @click="closePopup()" :disabled="loading">Cancel</v-btn>
          <v-spacer></v-spacer>
          <v-btn
            :loading="loading"
            @click="generateSalesInvoiceReport('whole_page',true); is_send_report = false;"
            color="primary"
            class="pr-3 text-capitalize"
          >
            <v-icon left>mdi-printer</v-icon>Print
          </v-btn>
          <v-btn
            :loading="loading"
            @click="generateSalesInvoiceReport(false); is_send_report = false; preview_pdf_dialog = true;"
            color="primary"
            class="pr-3 text-capitalize"
          >
            <v-icon left>mdi-content-save-outline</v-icon>Sign Online
          </v-btn>
          <v-btn
            @click="preview_pdf_dialog = true; is_send_report = true; generateSalesInvoiceReport(false);"
            color="primary"
            class="pr-3 text-capitalize"
          >
            <v-icon left>mdi-send</v-icon>Send for Signature
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="report_text_dialog" max-width="900" persistent>
      <v-card :loading="report_text_loading">
        <v-card-title class="headline">Update Text</v-card-title>
        <v-card-text>
          <v-row dense>
            <v-col cols="12">
              <vue-editor v-model="report_text_data.text" :editor-toolbar="customToolbar" />
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn color="error" @click="report_text_dialog = false">Cancel</v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            class="text-capitalize"
            @click="updateReportText('no')"
          >Update for this project</v-btn>
          <v-btn
            color="primary"
            class="text-capitalize"
            @click="updateReportText('yes')"
          >Update Template</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="preview_pdf_dialog" max-width="800" persistent>
      <v-card :loading="preview_pdf_loading">
        <v-card-text>
          <v-row dense>
            <v-col cols="12">
              <iframe :src="preview_page_link" frameborder="0" style="width:100%;height:800px"></iframe>
              <!-- <iframe
                :src="'https://docs.google.com/gview?embedded=true&url='+preview_page_link"
                frameborder="0"
                style="width:100%;height:800px"
              ></iframe>-->
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn
            color="error"
            @click="preview_pdf_dialog = false; user_sign_blob = []; customer_sign_blob = ''; active_page = 0;"
          >Cancel</v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            class="text-capitalize"
            @click="is_send_report ? email_dialog = true : signature_dialog = true"
            v-if="total_page == active_page"
            :loading="preview_pdf_loading"
          >Finish</v-btn>
          <v-btn
            v-else
            color="primary"
            class="text-capitalize"
            @click="is_send_report ? generateReport(false) : signature_dialog = true;"
            :loading="preview_pdf_loading"
          >Next Page</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <SendMailDialog
      :email_id="email_ids"
      :email_dialog="email_dialog"
      @closeDialog="closeSendMailDialog"
      @sendMail="sendMail"
    />
    <Signatura
      :customer_sign="customer_sign_blob"
      :active_page="active_page"
      @updateValue="updateParent"
      @clearValue="clearParent"
      :project_details="project_details"
      :signature_dialog="signature_dialog"
    />
  </div>
</template>
 <script>
import { VueEditor } from "vue2-editor";
import { getCompanyDetails } from "../../plugins/helper";
import Signatura from "../projects/Signatura";
import SendMailDialog from "../projects/SendMailDialog";
import axios from "../../plugins/axios";
import { mapMutations } from "vuex";
export default {
  data() {
    return {
      customToolbar: [
        [{ header: [false, 1, 2, 3, 4, 5, 6] }],
        ["bold", "italic", "underline", "strike"], // toggled buttons
        [
          { align: "" },
          { align: "center" },
          { align: "right" },
          { align: "justify" }
        ],
        //["blockquote", "code-block"],
        [{ list: "ordered" }, { list: "bullet" }, { list: "check" }],
        [{ indent: "-1" }, { indent: "+1" }],
        [{ color: [] }, { background: [] }],
        ["link", "image", "video"],
        //["clean"],
        // This is what I have added
        [{ size: ["small", false, "large"] }]
      ],
      preview_pdf_loading: "",
      total_page: "",
      active_page: 0,
      summary: {},
      user_sign_blob: [],
      customer_sign_blob: "",
      signature_dialog: false,
      loading: false,
      is_send_report: false,
      email_ids: null,
      email_id_arr: [],
      email_ids_error: null,
      email_dialog: false,
      send_pdf_loading: false,
      items: [],
      stones: [],
      report_texts: [],
      project_report_texts: [],
      company_details: getCompanyDetails(),
      report_text_data: {},
      report_text_dialog: false,
      report_text_loading: false,
      preview_pdf_dialog: false,
      preview_page_link: ""
    };
  },
  props: ["counter_top_sales_invoice_report", "project_details"],
  watch: {
    counter_top_sales_invoice_report: function(value) {
      if (value) {
        this.preview_page_link = "";
        this.active_page = 0;
        this.user_sign_blob = [];
        this.customer_sign_blob = "";
        this.getReportDetails();
        this.getTotalPage();
        this.getReportTexts();
      }
    }
  },
  computed: {
    user_name() {
      return localStorage.getItem("user_name");
    }
  },
  components: {
    VueEditor,
    Signatura,
    SendMailDialog
  },
  methods: {
    ...mapMutations("utils", ["setAlert"]),
    sendMail(variable) {
      this.email_id_arr = variable;
      this.sendSalesInvoiceReport();
    },
    itemFormatWithDollar(val) {
      if (val < 0) {
        val = val.toString();
        val = val.replace("-", "");
        return "($" + val + ")";
      } else {
        return "$" + val;
      }
    },
    closeSendMailDialog() {
      this.email_dialog = false;
      this.preview_pdf_dialog = false;
      this.user_sign_blob = [];
      this.customer_sign_blob = "";
      this.active_page = 0;
    },
    updateParent(variable) {
      if (variable.user_sign_blob) {
        this.user_sign_blob.push({
          page: this.active_page,
          sign_blob: variable.user_sign_blob
        });
      }
      if (variable.customer_sign_blob && this.active_page == 1) {
        this.customer_sign_blob = variable.customer_sign_blob;
      }
      this.signature_dialog = false;
      if (this.is_send_report) {
        if (this.total_page == this.active_page) {
          this.email_dialog = true;
          this.email_ids =
            this.project_details.customer.email +
            "@" +
            this.project_details.customer.email_domain.domain;
        } else {
          this.generateSalesInvoiceReport(false);
        }
      } else {
        if (this.total_page == this.active_page) {
          this.generateSalesInvoiceReport(true);
        } else {
          this.generateSalesInvoiceReport(false);
        }
      }
    },
    clearParent(variable) {
      console.log(variable);
      this.signature_dialog = false;
    },
    updateReportText(update_for_all_project) {
      this.report_text_data.project_id = this.project_details.project_id;
      this.report_text_data.update_for_all_project = update_for_all_project;
      this.report_text_loading = true;
      let _self = this;
      axios
        .post("update_project_report_text", this.report_text_data)
        .then(function() {
          _self.report_text_dialog = false;
          _self.getReportTexts();
          _self.report_text_loading = false;
        })
        .catch(function() {
          _self.report_text_loading = false;
        });
    },
    openReportTextDialog(report, section) {
      this.report_text_data.text = this.getReportText(report, section, true);
      this.report_text_data.report = report;
      this.report_text_data.section = section;
      this.report_text_dialog = true;
    },
    getReportText(report, section) {
      let report_text = "";
      this.project_report_texts.filter(item => {
        if (item.report == report && item.section == section) {
          report_text = item.text;
        }
      });
      if (!report_text) {
        this.report_texts.filter(item => {
          if (item.report == report && item.section == section) {
            report_text = item.text;
          }
        });
      }
      return report_text;
    },
    closePopup() {
      this.$emit("updateValue");
    },
    getTotalPage() {
      let company_data = localStorage.getItem("company_data");
      company_data = JSON.parse(company_data);
      var formData = new FormData();
      formData.append("project_id", this.project_details.project_id);
      formData.append("user_name", localStorage.getItem("user_id"));
      formData.append("company_id", company_data.company_id);
      formData.append("generate_pdf_flag", "get_total");
      this.loading = true;
      axios
        .post("generate_sales_invoice_pdf", formData, {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        })
        .then(response => {
          if (response.data.status) {
            this.total_page = response.data.total_page;
          }
          this.loading = false;
        })
        .catch(function(error) {
          console.log(error);
          this.loading = false;
        });
    },
    generateSalesInvoiceReport(is_past_page, direct_print = false) {
      this.preview_pdf_loading = true;
      this.active_page++;
      let company_data = localStorage.getItem("company_data");
      company_data = JSON.parse(company_data);
      // let url = 'flag=save&project_id='+this.project_details.project_id+'&user_name='+localStorage.getItem('user_id')+'&company_id='+company_data.company_id+'&sign='+this.sign_blob;
      var formData = new FormData();

      if (is_past_page) {
        if (this.user_sign_blob) {
          for (let key in this.user_sign_blob) {
            formData.append(
              `user_sign_blob[${this.user_sign_blob[key].page}]`,
              this.user_sign_blob[key].sign_blob
            );
          }
        }
        if (this.customer_sign_blob) {
          formData.append(`customer_sign_blob`, this.customer_sign_blob);
        }
        formData.append("generate_pdf_flag", "whole_page");
      } else {
        formData.append("generate_pdf_flag", "single_page");
      }
      formData.append("flag", "save");
      formData.append("project_id", this.project_details.project_id);
      formData.append("user_name", localStorage.getItem("user_id"));
      formData.append("company_id", company_data.company_id);
      formData.append("total_page", this.total_page);
      formData.append("active_page", this.active_page);
      formData.append("direct_print", direct_print);
      axios
        .post("generate_sales_invoice_pdf", formData, {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        })
        .then(response => {
          if (is_past_page) {
            if (response.data.status) {
              if (direct_print) {
                var File_url = response.data.file_url;
                window.open(File_url, "Download");
              } else {
                this.setAlert({
                  show: true,
                  variant: "primary",
                  message: response.data.message,
                  dismissCountDown: 0
                });
                this.closePopup();
              }
              this.preview_pdf_dialog = false;
            }
          } else {
            this.preview_page_link = response.data.preview_page_link;
          }
          this.preview_pdf_loading = false;
        })
        .catch(function(error) {
          console.log(error);
          this.preview_pdf_loading = false;
        });

      // let url = 'flag=save&project_id='+this.project_details.project_id+'&user_name='+localStorage.getItem('user_id')+'&company_id='+company_data.company_id+'&sign='+this.sign_blob;
      // this.loading = true;
      // axios
      // .get("generate_sales_invoice_pdf?" + url)
      // .then(response => {
      //   if(response.data.status) {
      //     this.setAlert({
      //       show: true,
      //       variant: "primary",
      //       message: response.data.message,
      //       dismissCountDown: 0
      //     });
      //   }
      //   this.loading = false;
      //   this.closePopup();
      // })
      // .catch(function(error) {
      //   console.log(error);
      //   this.loading = false;
      // });
    },
    sendSalesInvoiceReport() {
      let company_data = localStorage.getItem("company_data");
      company_data = JSON.parse(company_data);
      let data = {
        flag: "mail",
        project_id: this.project_details.project_id,
        user_name: localStorage.getItem("user_id"),
        company_id: company_data.company_id,
        active_page: this.active_page,
        total_page: this.total_page,
        email_id_arr: this.email_id_arr,
        email_ids: this.email_ids,
        generate_pdf_flag: "whole_page"
      };
      if (this.user_sign_blob) {
        data.user_sign_blob = this.user_sign_blob;
      }
      if (this.customer_sign_blob) {
        data.customer_sign_blob = this.customer_sign_blob;
      }

      this.send_pdf_loading = true;
      axios
        .post("generate_sales_invoice_pdf", data)
        .then(response => {
          this.email_ids_error = null;
          if (response.data.status) {
            this.email_dialog = false;
            this.setAlert({
              show: true,
              variant: "primary",
              message: response.data.message,
              dismissCountDown: 0
            });
            this.preview_pdf_dialog = false;
            this.closePopup();
          } else {
            this.email_ids_error = response.data.errors["email_ids"];
          }
          this.send_pdf_loading = false;
        })
        .catch(function(error) {
          console.log(error);
          this.send_pdf_loading = false;
        });
    },
    getReportDetails() {
      let _self = this;
      this.loading = true;
      axios
        .get(
          "get_counter_top_sales_invoice_report_details?project_id=" +
            this.project_details.project_id +
            "&project_data_flag=5"
        )
        .then(response => {
          let response_data = response.data;
          _self.items = response_data.data;
          _self.stones = response_data.stone;
          _self.summary = response_data.summary;
          _self.loading = false;
        })
        .catch(function(error) {
          console.log(error);
          _self.loading = false;
        });
    },
    getReportTexts() {
      let _self = this;
      this.loading = true;
      axios
        .get("get_report_texts?project_id=" + this.project_details.project_id)
        .then(function(res) {
          _self.project_report_texts = res.data.project_report_texts;
          _self.report_texts = res.data.data;
          _self.loading = false;
        })
        .then(function() {
          _self.loading = false;
        });
    }
  },
  created: function() {},
  mounted: function() {
    // this.$refs.userSignaturePad.openSignaturePad();
    // this.$refs.customerSignaturePad.openSignaturePad();
  }
};
</script>
 
 <style>
.sales-invoice-report p {
  margin-bottom: 0px;
}
</style>
 